import { gql } from '@apollo/client';

export const ALL_CURRENT_ORGANISATION_USERS = gql`
  query AllCurrentOrganisationUsers {
    users: allCurrentOrganisationUsers {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`;
